<template>
    <b-container>
        <b-modal
            v-model="openModal"
            header-bg-variant="dark"
            header-text-variant="light"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
            
            <template v-slot:modal-title>
                AGREGAR AL CARRITO
                <div class="pb-2" v-if="item.name">{{item.name}}</div>
                <div class="pb-2" v-else>{{item.nombre}}</div>
            </template>
            <p> Ingrese la cantidad de este producto que desea agregar al carrito de compras</p>
            <b-row class="my-1 justify-content-md-center" align-v="center" >
                <b-col sm="3" class="text-center ">
                    <strong>Cantidad</strong>
                </b-col>
                <b-col sm="5">
                    <b-input-group>
                        <b-input-group-prepend>
                        <b-btn variant="outline-secondary" @click="decrement()">-</b-btn>
                        </b-input-group-prepend>

                        <b-form-input type="number" min="1" oninput="validity.valid||(value='');" v-model="itemQuantity"></b-form-input>

                        <b-input-group-append>
                        <b-btn variant="outline-secondary" @click="increment()">+</b-btn>
                        </b-input-group-append>
                </b-input-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <div>
                <b-button variant="danger" class="mr-2"  @click.prevent="closeModal">
                    Cancelar
                </b-button>
                <b-button variant="success" @click.prevent="addItemToCart(item)">
                    Agregar
                </b-button>
                </div>
            </template>
        </b-modal>
    </b-container>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
export default {
    props: ['item', 'openModal'],
    data(){
        return{
            itemQuantity: 1,
        }
    },
    methods:{
         ...mapActions('configuration', {
          _getCartCount: 'getCartItemsCountByUser',
        }),
        ...mapMutations(['setLoading']),
        increment() {
            this.itemQuantity++;
            },
        decrement() {
            if (this.itemQuantity === 1 || this.itemQuantity <= 1) {
                console.log('no es posible')
            } else {
                this.itemQuantity--;
            }
        },
        closeModal(){
            this.itemQuantity = 1;
            this.$emit('close-modal');
        },
        async addItemToCart(datos){
            this.setLoading(true)
            this.$emit('close-modal')
            if(datos.empresa_id){
                let codigo = datos.codigo;
                let cantidad = this.itemQuantity;
                let data = {codigo, cantidad}
                await this.$conectar.post('/articulos/add-item-empresa-to-cart', data)
                .then(response =>{
                    if (response.data.error == false) { 
                        this.$bvToast.toast(response.data.mensaje, {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                        })
                        this._getCartCount();
                    }else{
                        this.$bvToast.toast(response.data.mensaje, {
                            title: "Respuesta del servidor",
                            variant: "danger",
                            solid: true
                        })
                    }
                })
                .catch(error => {
                    this.$bvToast.toast('Parece que hubo un error en el servidor', {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                    console.log(error);
                })
            }else{
                let referencia = '';
                if(datos.reference){
                    referencia = datos.reference;
                }else{
                    referencia = datos.codigo;
                }
                let cantidad = this.itemQuantity;
                let quantity = datos.quantity;
                let enviar = {referencia, cantidad, quantity }
                await this.$conectar.post('/articulos/add-item-to-cart', enviar)
                .then(response =>{
                    if (response.data.error == false) { 
                        this.$bvToast.toast(response.data.mensaje, {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                        })
                        this._getCartCount();
                    }else{
                        this.$bvToast.toast(response.data.mensaje, {
                            title: "Respuesta del servidor",
                            variant: "danger",
                            solid: true
                        })
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$bvToast.toast('Parece que hubo un error en el servidor', {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                })
            }
            this.setLoading(false)
        },
        
    }
}
</script>